import React, { useState, useEffect, MouseEvent } from 'react';
import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';

import { Genre } from 'common/constants/types';
import RightPaneAttributesContainer from './RightPaneAttributesContainer';
import styles from './RightPane.module.scss';

const renderGenreTitles = (genreTitles: { index: number; title: string }[]) =>
  genreTitles.map(genre => (
    <div
      data-index={genre.index}
      key={genre.index}
      style={{
        cursor: 'pointer',
        marginLeft: '15px',
        marginTop: '15px',
        textTransform: 'uppercase',
      }}
    >
      {genre.title}
    </div>
  ));

interface Props {
  genres?: Genre[];
}

const RightPane = ({ genres = [] }: Props) => {
  // first genre is selected by default
  const firstGenre = genres[0]; // extract as variable for static type checking
  const [selectedGenre, setGenre] = useState(firstGenre);

  useEffect(() => {
    setGenre(firstGenre);
  }, [firstGenre]);

  if (_isEmpty(genres)) {
    return <div />;
  }

  const genreTitles = genres.map((genre, index) => ({
    index,
    title: genre.description,
  }));

  return selectedGenre ? (
    <div className={styles.rightPane}>
      <div
        className={styles.selectGenreButton}
        // TODO: dataset doesn't exist on EventTarget, find the proper type for event
        onClick={(event: MouseEvent) => {
          if (_get(event, 'target.dataset.index')) {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const index: number = parseInt((event.target as HTMLElement).dataset.index!, 10);
            setGenre(genres[index]);
          }
        }}
        role="button"
      >
        {renderGenreTitles(genreTitles)}
      </div>
      <div className={styles.attributesContainer}>
        <RightPaneAttributesContainer attrData={selectedGenre.sections} />
      </div>
    </div>
  ) : (
    <div />
  );
};

export default RightPane;
